import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";

const ShopColor = ({ colors, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [colorSelected, setColorSelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.color
  );
  const [refresh, setRefresh] = useState(true);
  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  function toColor(i) {
    /*var hex = (i & 0xFF).toString(16) +
            ((i >> 8) & 0xFF).toString(16) +
            ((i >> 16) & 0xFF).toString(16) +
            ((i >> 24) & 0xFF).toString(16);
  
    hex = hex.substring(0, 6);
    
    return "#" + hex;*/
    var r = Math.floor(i / 65536);
    var g = Math.floor((i - r * 65536) / 256);
    var b = Math.floor(i - r * 65536 - g * 256);
    var rHex = Number(r).toString(16);
    var gHex = Number(g).toString(16);
    var bHex = Number(b).toString(16);
    rHex = rHex.length < 2 ? "0" + rHex : rHex;
    gHex = gHex.length < 2 ? "0" + gHex : gHex;
    bHex = bHex.length < 2 ? "0" + bHex : bHex;
    return "#" + bHex + gHex + rHex;
  }
  useEffect(() => {
    setColorSelected(JSON.parse(sessionStorage.getItem("filter"))?.color);
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Colori
      </div>
      {/*<div className="shopping-cart-btn btn-hover text-center"  style={{padding:"10px"}}>
            <a style={{padding:"10px", border:"1px gray solid",display:"block", width:"100%"}}  onClick={() => CambioStato()}  >Colori</a>
        </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag">
          {colors ? (
            <ul
              style={{
                display: "grid",
                placeItems: "center",
                gridTemplateColumns: "repeat(8, 1fr)",
              }}
            >
              <li style={{ gridColumn: "span 3" }}>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allColors"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".colors")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      if (e.currentTarget.classList.contains("active"))
                        getSortParams("color", "all", "-");
                      else getSortParams("color", "all", "+");
                      //getSortParams("color", "");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutti i colori{" "}
                  </button>
                </div>
              </li>
              {colors.map((color, key) => {
                var colorString = color
                  .split(";")[0]
                  .split("-")[1]
                  .split(" (")[0];
                var hexColor = color.split(";")[1];
                var colorSigla = color.split(";")[0].split("-")[0];
                return (
                  <li key={key}>
                    <div
                      className="sidebar-widget-list-left"
                      style={{ padding: "0px 0px 0px 0px" }}
                    >
                      <button
                        className={
                          "colors " +
                          (colorSelected?.split("|").includes(colorSigla)
                            ? "active"
                            : "")
                        }
                        onClick={(e) => {
                          document
                            .querySelector("#allColors")
                            .classList.remove("active");
                          if (e.currentTarget.classList.contains("active"))
                            getSortParams("color", colorSigla, "-");
                          else getSortParams("color", colorSigla, "+");
                          //getSortParams("color", color);
                          setActiveSort(e);
                        }}
                        style={{
                          fontSize: "x-small",
                          verticalAlign: "middle",
                          padding: "0px 5px 0px 0px",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor:
                              hexColor != "undefined" ? toColor(hexColor) : "",
                            backgroundImage:
                              hexColor != "undefined"
                                ? null
                                : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                                  color.split("-")[0] +
                                  ".png')",
                            backgroundSize: "contain",
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            content: "",
                            transition: "0.3s",
                            display: "inline-block",
                            verticalAlign: "middle",
                            border: "1px black solid",
                          }}
                        ></span>
                        <br />
                        <span className="checkmark" /> {colorSigla}{" "}
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopColor.propTypes = {
  colors: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopColor;
